import {swiperInit} from './swiperInit';

export const downloadListSwiper = (() => {
  swiperInit({
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    selector: '.downloadListSwiper',
  })
})();
